import { createGlobalStyle } from 'styled-components'
import { giphyWhite } from '@giphy/js-brand'
import { mobile } from 'shared/util/media-query'

const GiphyMarketingStyles = createGlobalStyle`
    body {
        margin: 0;
        width: 100%;
        color: ${giphyWhite};
        background: black;
    }

    body, html {
        text-align: unset;
    }

    a {
        text-decoration: none;
        border-bottom: none;
        font-size: 16px;
        font-weight: bold;
        font-family: 'interface', serif;
    }

    h1 {
        font-family: 'NexaBlack', serif;
        font-size: 46px;
        line-height: 54px;
    }

    p {
        font-family: 'interface';
        font-size: 18px;
        font-weight: normal;
        height: 78px;
        letter-spacing: 0.4px;
        line-height: 26px;
        width: 429px;
        opacity: 0.8;
    }

    ${mobile.css`
        h1 {
            font-size: 32px;
            line-height: 38px;
        }

        p {
            letter-spacing: 0px;
        }
    `}
`

export default GiphyMarketingStyles
